import { FileEntity } from "../Entity"

const BASE_URL = 'http://123.249.93.76:9012/api/'
// const BASE_URL = 'http://192.168.1.14:9011/'

const URL_LOGIN = BASE_URL + 'user/login'
const URL_IMG = BASE_URL + 'captchaImage'
const URL_fileType_getFileType = BASE_URL + 'fileType/getFileType'
const URL_fileType_addFileTYpe = BASE_URL + 'fileType/addFileTYpe'
const URL_fileType_delete = BASE_URL + 'fileType/delete'
const URL_fileType_moveUp = BASE_URL + 'fileType/moveUp'
const URL_fileType_moveDown = BASE_URL + 'fileType/moveDown'
const URL_fileType_updateName = BASE_URL + 'fileType/updateName'
const URL_file_getFileList = BASE_URL + 'file/getFileList'
const URL_file_deleteFile = BASE_URL + 'file/deleteFile'
const URL_file_deleteFileEver = BASE_URL + 'file/deleteFileEver'
const URL_file_uploadFile = BASE_URL + 'file/uploadFile'
const URL_file_downloadFile = BASE_URL + 'file/downloadFile'
const URL_file_getPreviewUrl = BASE_URL + 'file/getPreviewUrl'

const URL_file_searchFile = BASE_URL + 'file/searchFile'
const URL_user_getUsers = BASE_URL + 'user/getUsers'
const URL_user_getAdminUsers = BASE_URL + 'user/getAdminUsers'
const URL_user_searchUsers = BASE_URL + 'user/searchUsers'
const URL_user_setAdmin = BASE_URL + 'user/setAdmin'
const URL_user_delete_user = BASE_URL + 'user/delete'
const URL_user_addUser = BASE_URL + 'user/addUser'
const URL_updatePwd = BASE_URL + 'user/updatePwd'
const URL_logout = BASE_URL + 'user/logout'
const URL_updateFile = BASE_URL + 'file/updateFile'

type MyMethod = 'GET' | 'POST'

interface RequestUrlProps {
  url: string
  method: MyMethod
  success: (data?: any) => void
  body?: any
  fail?: (msg: any) => void
  finally?: () => void
  headers?: {}
  noToken?: boolean
  isMultipart?: boolean
}

const requestUrl = async (props: RequestUrlProps) => {
  // const navigate = useNavigate()
  const token = sessionStorage.getItem('token')
  let h = new Headers({})
  if (!props.noToken) h.set('Authorization', 'Xyxyzka ' + token) //带token
  if (!props.isMultipart) h.set('Content-Type', 'application/json')
  const request = async () => {
    await fetch(props.url, {
      method: props.method,
      body: props.body,
      headers: h,
    })
      .then(response => {
        return response.json()
      })
      .then(data => {
        if (data.status) {
          //表示 请求服务器错误
          if (props.fail) props.fail('请求失败' + data.status)
          return
        }
        if (data.code) {
          if (data.code == 200) {
            props.success(data.data)
          } else {

            if (data.code == 401) {
              //表示token过期重新登录
              sessionStorage.removeItem('token')
              if (props.fail) props.fail('登录过期，请重新刷新页面登录')
            } else {
              if (props.fail) props.fail(data.msg)
            }
          }
        } else {
          if (props.fail) props.fail('请求失败')
        }
      })
      .catch(error => {
        //   console.error('Error uploading file:', error);
        if (props.fail) props.fail(error)
      })
      .finally(() => {
        if (props.finally) props.finally()
      })
  }
  return request()

}

/**
 * 下载文件 带token
 * @param f 
 */
const down = (f: FileEntity) => {
  const token = sessionStorage.getItem('token')
  let url = URL_file_downloadFile + '?id=' + f.id
  var xhr = new XMLHttpRequest();
  xhr.open('GET', url, true);
  //设置请求头参数的方式,如果没有可忽略此行代码
  xhr.setRequestHeader("Authorization", `Xyxyzka ${token}`)
  //设置响应类型为 blob   xhr.open必须为 异步
  xhr.responseType = 'blob';
  console.log(f.fileSuffix)
  //关键部分
  xhr.onload = function (e) {
    //如果请求执行成功
    if (this.status == 200) {
      let blob = this.response;
      let a = document.createElement('a');
      // blob.type = "application/octet-stream";
      let url = window.URL.createObjectURL(blob);
      a.href = url;
      a.download = (f.name ? f.name : '') + (f.fileSuffix ? f.fileSuffix : '')
      document.body.appendChild(a); // 火狐浏览器 必须把元素插入body中
      a.click();
      document.body.removeChild(a);
      //释放之前创建的URL对象
      window.URL.revokeObjectURL(url);
    }
  }
  xhr.send()

}

function download(blob: Blob, filename?: string) {
  const a: any = document.createElement('a')
  a.download = filename
  const blobUrl = URL.createObjectURL(blob)
  a.href = blobUrl
  document.body.appendChild(a)
  a.click()
  a.remove()
  URL.revokeObjectURL(blobUrl)
}

export {
  requestUrl, BASE_URL, URL_LOGIN, URL_IMG, URL_fileType_getFileType,
  URL_fileType_addFileTYpe, URL_fileType_delete, URL_fileType_moveUp,
  URL_fileType_moveDown, URL_fileType_updateName, URL_file_getFileList,
  URL_file_uploadFile, URL_file_deleteFile, URL_file_downloadFile,
  URL_file_getPreviewUrl, down, URL_file_deleteFileEver, URL_file_searchFile,
  URL_user_getUsers, URL_user_getAdminUsers, URL_user_searchUsers, URL_user_setAdmin,
  URL_user_addUser, URL_updatePwd, URL_logout, URL_updateFile,URL_user_delete_user

}
export type { MyMethod }

